import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Preventivo from "@/pages/Preventivo";
import Servizi from "@/pages/Servizi";
import ServiceCategory from "@/pages/ServiceCategory";
import Materiali from "@/pages/Materiali";
import ComeFunziona from "@/pages/ComeFunziona";
import Metodo from "@/pages/Metodo";
import StatoRichiesta from "@/pages/StatoRichiesta";
import ChiSiamo from "@/pages/ChiSiamo";
import Contatti from "@/pages/Contatti";
import Faq from "@/pages/Faq";
import LegalPage from "@/pages/LegalPage";
import NotFound from "@/pages/NotFound";
import { Seo } from "@/components/seo/Seo";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Seo />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servizi" element={<Servizi />} />
          <Route path="/servizi/:slug" element={<ServiceCategory />} />
          <Route path="/materiali" element={<Materiali />} />
          <Route path="/come-funziona" element={<ComeFunziona />} />
          <Route path="/metodo" element={<Metodo />} />
          <Route path="/stato-richiesta" element={<StatoRichiesta />} />
          <Route path="/chi-siamo" element={<ChiSiamo />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/preventivo" element={<Preventivo />} />
          {/* Legal & informative pages (official content) */}
          <Route path="/privacy-policy" element={<LegalPage slug="privacy-policy" />} />
          <Route path="/cookie-policy" element={<LegalPage slug="cookie-policy" />} />
          <Route path="/termini-condizioni" element={<LegalPage slug="termini-condizioni" />} />
          <Route path="/resi-rimborsi" element={<LegalPage slug="resi-rimborsi" />} />
          <Route path="/spedizioni" element={<LegalPage slug="spedizioni" />} />
          <Route path="/informativa-legale" element={<LegalPage slug="informativa-legale" />} />
          {/* Legacy aliases — keep old links working */}
          <Route path="/privacy" element={<LegalPage slug="privacy" />} />
          <Route path="/cookie" element={<LegalPage slug="cookie" />} />
          <Route path="/termini" element={<LegalPage slug="termini" />} />
          <Route path="/resi" element={<LegalPage slug="resi" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
